import React from 'react';
import { Select as BasewebSelect } from 'baseui/select';
import { selectCustomOverrides } from './select-overrides.const';
import { useStyletron } from 'baseui';
import { SelectProps } from './select-props.interface';
import { IconsProps } from '@dapp/multi-lib/ui/icons';

const Select = (props: SelectProps) => {
  const [_, theme] = useStyletron();
  const { value, overrides, ...rest } = props;
  const iconSetoveride: Partial<IconsProps> = {
    icon: 'expand_more',
    fillColor: theme.colors.white,
    ...(props?.iconSet && { ...props.iconSet }),
  };
  if (!overrides) return <>no overrides set</>;
  const selectOverrides = selectCustomOverrides(overrides, iconSetoveride);
  return <BasewebSelect value={value} overrides={selectOverrides} {...rest} />;
};

export default Select;
